import angular from 'angular';
import { pull } from 'lodash';
import moment from 'moment';
import { InspectionRepairItemForm } from './inspection-repair-item-form';

module.exports = angular.module('admin.directives.inspection_panel', [
  require('admin/models/inspection_report'),
  require('admin/models/inspection_repair_item'),
  require('common/services/times'),
  require('common/filters/in'),
])
.directive('ocInspectionPanel', function(
  InspectionReport,
  InspectionRepairItem,
  InspectorRoleToDocumentType,
  AvailableTimes) {
  return {
    restrict: 'E',
    scope: {
      flip: '=',
      address: '=',
      inspection: '=',
      workOrders: '<',
      workOrderCostItems: '<',
      onDelete: '&',
    },
    template: require('./inspection-panel.jade')(),
    bindToController: true,
    controllerAs: '$ctrl',
    controller: class {
      AVAILABLE_TIMES = AvailableTimes;

      constructor(InspectorRoleToDocumentType) {
        this.InspectorRoleToDocumentType = InspectorRoleToDocumentType;
        this.resetInspectionRepairItem();
        this.onDeleteRepairItem = (report, item) => pull(report.inspection_repair_items, item);
      }

      activateInspection() {
        this.inspection.$activate();
      }

      resetInspectionRepairItem() {
        this.newInspectionRepairItemForm = new InspectionRepairItemForm();
      }

      addInspectionTimezone(time) {
        return `${time} ${moment.tz(this.inspection.timezone).zoneAbbr()}`;
      }

      createRepairItem(inspectionReport) {
        let newInspectionRepairItem = new InspectionRepairItem({
          inspection_id: this.inspection.id,
          inspection_report_id: inspectionReport.id,
        });
        this.newInspectionRepairItemForm.toInspectionRepairItem(newInspectionRepairItem);
        newInspectionRepairItem.$save(() => {
          inspectionReport.inspection_repair_items.push(newInspectionRepairItem);
          this.resetInspectionRepairItem();
        });
      }

      removeInspectionReport(inspectionReport) {
        // If the inspection report has not been saved yet just yank it
        // out of the collection
        if (!inspectionReport.id) {
          pull(this.inspection.inspection_reports, inspectionReport);
          return;
        }

        let report = new InspectionReport(inspectionReport);
        report.inspection_id = this.inspection.id;

        report.$delete(() => {
          pull(this.inspection.inspection_reports, inspectionReport);
        });
      }

      submitInspectionReport(inspectionReport) {
        let report = new InspectionReport(inspectionReport);
        report.inspection_id = this.inspection.id;
        report.$submit(() => {
          this.inspection.$get();
        });
      }

      updateInspection() {
        return this.inspection.$update();
      }

      deleteInspection() {
        this.inspection.$delete().then(() => {
          return this.onDelete();
        });
      }
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/inspections/inspection-panel.js
 **/